var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGiftFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8540_23711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.33338C10.4681 1.33332 10.9281 1.45653 11.3336 1.69062C11.739 1.92471 12.0757 2.26142 12.3098 2.66691C12.5439 3.07239 12.667 3.53235 12.6669 4.00054C12.6669 4.46873 12.5435 4.92865 12.3093 5.33405L15.3333 5.33338V6.66671H14V13.3334C14 13.5102 13.9297 13.6798 13.8047 13.8048C13.6797 13.9298 13.5101 14 13.3333 14H2.66663C2.48981 14 2.32025 13.9298 2.19522 13.8048C2.0702 13.6798 1.99996 13.5102 1.99996 13.3334V6.66671H0.666626V5.33338L3.69063 5.33405C3.35987 4.7613 3.25375 4.08608 3.39288 3.43949C3.53201 2.7929 3.90646 2.22109 4.44352 1.83508C4.98057 1.44907 5.64191 1.27641 6.29912 1.35063C6.95634 1.42485 7.56251 1.74065 7.99996 2.23671C8.24969 1.9523 8.55733 1.72456 8.90227 1.56876C9.24721 1.41297 9.62147 1.33271 9.99996 1.33338V1.33338ZM8.66663 6.66671H7.33329V13.3334H8.66663V6.66671ZM5.99996 2.66671C5.65397 2.66516 5.32093 2.79817 5.07119 3.03763C4.82145 3.27709 4.67458 3.60426 4.6616 3.95C4.64862 4.29575 4.77054 4.63301 5.00162 4.89052C5.2327 5.14804 5.55483 5.30564 5.89996 5.33004L5.99996 5.33338H7.33329V4.00004C7.33331 3.68142 7.21922 3.37332 7.01169 3.13155C6.80416 2.88978 6.51691 2.73032 6.20196 2.68204L6.09929 2.67004L5.99996 2.66671ZM9.99996 2.66671C9.66357 2.66661 9.33958 2.79365 9.09293 3.02238C8.84627 3.2511 8.69519 3.56461 8.66996 3.90004L8.66663 4.00004V5.33338H9.99996C10.3363 5.33348 10.6603 5.20644 10.907 4.97771C11.1536 4.74899 11.3047 4.43548 11.33 4.10004L11.3333 4.00004C11.3333 3.64642 11.1928 3.30728 10.9428 3.05724C10.6927 2.80719 10.3536 2.66671 9.99996 2.66671V2.66671Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8540_23711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgGiftFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gift-fill.53764f3e538fd675e58299372a28c9f1.svg";